import { useId, type ReactNode } from 'react';

/**
 * A label on the left and its control on the right, the way the office reads a
 * form. A row of several controls (a name in two parts, an address, a rate) is
 * a `group` named by the label, with its hint and error tied to it, so a screen
 * reader hears them together; a single control carries its own label.
 */
export function Row(props: {
  label: string;
  error?: string;
  hint?: string;
  children: ReactNode;
  wide?: boolean;
  group?: boolean;
}) {
  const id = useId();
  const describedBy =
    [props.hint && `${id}-hint`, props.error && `${id}-error`].filter(Boolean).join(' ') ||
    undefined;
  return (
    <div className={props.error ? 'frow invalid' : 'frow'}>
      <div className="frow-label" id={`${id}-label`}>
        {props.label}
      </div>
      <div
        className={props.wide ? 'frow-body wide' : 'frow-body'}
        role={props.group ? 'group' : undefined}
        aria-labelledby={props.group ? `${id}-label` : undefined}
        aria-describedby={props.group ? describedBy : undefined}
      >
        {props.children}
        {props.hint && (
          <span className="muted hint" id={`${id}-hint`}>
            {props.hint}
          </span>
        )}
        {props.error && (
          <span className="error" id={`${id}-error`}>
            {props.error}
          </span>
        )}
      </div>
    </div>
  );
}
